(function () {
  document.documentElement.classList.add('ca-product-rail-js');

  document.addEventListener('click', function (event) {
    var filterButton = event.target.closest('[data-ca-product-rail-filter]');

    if (!filterButton) {
      return;
    }

    var rail = filterButton.closest('[data-ca-product-rail]');
    var filterName = filterButton.getAttribute('data-ca-product-rail-filter');

    if (!rail || !filterName) {
      return;
    }

    rail.querySelectorAll('[data-ca-product-rail-filter]').forEach(function (button) {
      var isActive = button === filterButton;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    rail.querySelectorAll('[data-ca-product-rail-panel]').forEach(function (panel) {
      panel.classList.toggle('is-active', panel.getAttribute('data-ca-product-rail-panel') === filterName);
    });
  });
})();
